import DOMPurify from 'dompurify';
import { CSSProperties } from 'react';
import { RichTextEditor } from '../richtTextEditor/richtTextEditor';

export interface FormattedTextProps {
  value: string;
  style?: CSSProperties;
}

export const FormattedText = ({ value, style }: FormattedTextProps) => {
  const sanitizedHtml = DOMPurify.sanitize(value);
  return (
    <div style={style}>
      <RichTextEditor
        value={sanitizedHtml}
        readOnly
        namespace="formatted-text"
      />
    </div>
  );
};
